/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Tab_Credit_PoolInputs */



/**
* | output |
* | --- |
* | "Token Credit Pool" |
*
* @param {Usage_Tab_Credit_PoolInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_credit_pool = /** @type {((inputs?: Usage_Tab_Credit_PoolInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Credit_PoolInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Token-Guthaben-Pool")
	return /** @type {LocalizedString} */ ("Token Credit Pool")
});